import React, { useEffect, useRef } from "react";
import { getDynamicData } from "~/common/Store/actions/updateUserAndChatFromOrigin";
import loadCustomerIoAnalytics from "~/analytics/CustomerIo/loadCustomerIoAnalytics";
import { handlePageView } from "./PageView/handlePageView";
import { dispatchConductricsEvent } from "./Conductrics";
import { getElementsAndAttachEvents } from "./CustomerIo/AccountEvents";
import { getAndUpdateVariationIds } from "~/Gtm/AbTestTracking/variationId";
import { sendLastClickPublisherEventIfEligible } from "~/analytics/Taboola/lastClickPublisher";

// Rendered in main.js as well as in App.tsx to ensure it is loaded on every page
const Analytics = () => {
  const hasRan = useRef<boolean>(false);

  async function handleWaitUser(): Promise<void> {
    await getDynamicData;
  }

  // Run in useEffect to ensure all tracking is only loaded once and only on the client
  useEffect(() => {
    if (!hasRan.current) {
      hasRan.current = true;
      handleWaitUser().then(() => {
        dispatchConductricsEvent();
        loadCustomerIoAnalytics();
        handlePageView();
        getElementsAndAttachEvents();
        getAndUpdateVariationIds();
        sendLastClickPublisherEventIfEligible();
      });
    }
  }, []);
  return <></>;
};
export default Analytics;
